export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  coverImage: string;
  publishedAt: string;
  readTime: string;
  author: string;
  views: number;
  tags: string[];
  relatedArticles: string[];
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'mou-danghong-xiaosheng-yuehui-baoliao',
    title: '某当红小生深夜与神秘女子约会实锤！酒店共度三小时被拍，粉丝集体脱粉',
    excerpt: '据知情人士透露，这位以"纯情人设"著称的流量男星昨晚被拍到与一名长发女子进入某五星级酒店，三小时后独自离开。更劲爆的是，该女子疑似已婚...',
    content: `<p>昨日深夜，某知名狗仔队在社交平台上放出重磅爆料，一位以"清纯人设"走红的一线流量男星被拍到与神秘女子深夜密会。据现场照片显示，两人于晚上十一点左右先后进入某五星级酒店，直到凌晨两点才一前一后离开。</p>

<p>爆料一经发布，迅速登上微博热搜榜首，阅读量在半小时内突破五千万。粉丝群体中炸开了锅，不少铁粉表示难以接受，纷纷在评论区留言"房子塌了"。</p>

<h3>酒店密会细节曝光</h3>

<p>据狗仔队描述，当晚该男子戴着黑色鸭舌帽和口罩，刻意压低帽檐。然而标志性的走路姿势和身高体型还是被一眼认出。女子则包裹得更为严实，全程低头快步走入酒店大堂。</p>

<p>更值得注意的是，该女子左手无名指上戴着一枚明显的婚戒。有网友通过戒指款式和身形比对，怀疑该女子疑似某已婚企业高管的太太。如果这一猜测属实，事件的性质将更加严重。</p>

<h3>工作室回应引发更多猜测</h3>

<p>事件发酵后，该男星工作室于凌晨三点紧急发布声明，称"艺人当晚系与圈内好友聚餐，请大家不要过度解读"。然而网友发现声明中只字未提"酒店"二字，且聚餐为什么要去五星级酒店、为什么要深夜单独相处等问题均未得到解释。</p>

<p>截至目前，该男星个人微博已掉粉超过二十万，多个代言品牌官方微博已搜索不到与其相关内容。事件仍在持续发酵中，吃瓜群众们表示"坐等后续"。</p>`,
    categoryId: '1',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=celebrity%20paparazzi%20night%20scene%2C%20luxury%20hotel%20entrance%20with%20flash%20photography%2C%20mysterious%20atmosphere%2C%20warm%20amber%20street%20lights%2C%20cinematic%20noir%20style%2C%20editorial%20journalism%20photography&width=800&height=500&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-07-01',
    readTime: '5分钟',
    author: '瓜田守望者',
    views: 3854200,
    tags: ['明星八卦', '恋情实锤', '人设崩塌', '流量小生'],
    relatedArticles: ['2', '7', '10'],
  },
  {
    id: '2',
    slug: 'wanghong-meizhuang-daihuo-fanche',
    title: '千万粉美妆博主直播翻车！推荐的"大牌平替"竟是三无产品，粉丝用后烂脸',
    excerpt: '坐拥一千二百万粉丝的美妆博主"XX酱"昨晚直播推荐了一款号称"大牌平替"的精华液，结果有粉丝购买使用后出现严重过敏，扒出产品竟是小作坊生产的三无产品...',
    content: `<p>昨晚，知名美妆博主"蜜桃酱酱"在直播间激情推荐一款名为"焕颜奇迹精华"的产品，声称是某国际大牌的"完美平替"，价格仅为正品的十分之一。直播间当晚下单量突破十万单，销售额超过三百万元。</p>

<p>然而今天一早，多个粉丝在社交平台上晒出使用后脸部红肿、起疹的照片，引发轩然大波。有细心的网友扒出，该产品生产厂家竟是一家注册资本仅十万元的小作坊，生产许可证编号在国家药监局官网查无此号。</p>

<h3>粉丝集体维权</h3>

<p>截至目前，"蜜桃酱酱烂脸"话题已登上微博热搜前三位。受害粉丝组建了维权群，群内人数已超过两千人。多名受害者表示已准备联合起诉该博主和生产厂家。</p>

<p>更令粉丝愤怒的是，在事件发酵后，该博主非但没有道歉，反而在粉丝群中发消息称"个人体质不同， product本身没问题"，并连夜删除了所有相关直播回放。</p>`,
    categoryId: '2',
    categoryName: '网红黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=makeup%20products%20scattered%20on%20vanity%20table%20with%20harsh%20red%20warning%20light%2C%20beauty%20influencer%20livestream%20setup%2C%20dramatic%20lighting%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=500&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-06-30',
    readTime: '4分钟',
    author: '打假先锋',
    views: 2567800,
    tags: ['网红翻车', '直播带货', '三无产品', '美妆博主'],
    relatedArticles: ['1', '6', '8'],
  },
  {
    id: '3',
    slug: 'mou-cheng-shizhang-guanliao-tanfu',
    title: '震惊！某市副市长落马细节曝光，家中搜出数千万现金和上百块名表',
    excerpt: '据中央纪委国家监委通报，某市副市长李某涉嫌严重违纪违法被查。搜查其多处住所时， investigators 发现床底下、衣柜里、甚至冰箱中都塞满了现金，经清点共计超过四千万元...',
    content: `<p>今日，中央纪委国家监委发布通报，某市副市长李某因涉嫌严重违纪违法接受纪律审查和监察调查。据悉，李某在担任副市长期间分管城建和土地规划，权力极大。</p>

<p>搜查人员在对其三处住所进行搜查时，发现了令人震惊的一幕：主卧床垫下堆满了成捆的现金，衣帽间深处藏着上百块名贵手表，甚至冰箱冷冻室里也塞满了用保鲜膜包裹的钞票。</p>

<h3>四千万元现金清点耗时一整天</h3>

<p>据参与搜查的工作人员透露，现场清点的四十多名工作人员用了将近一天时间才将所有现金清点完毕，最终金额高达四千三百余万元。此外还查获名贵手表一百二十六块、珠宝首饰若干、房产证数十本。</p>

<p>李某的邻居在接受采访时表示"完全没想到"，称李某平时"非常朴素"，上下班骑自行车，穿的衣服也很普通，"完全看不出是个贪官"。</p>`,
    categoryId: '3',
    categoryName: '社会热点',
    coverImage: 'https://readdy.ai/api/search-image?query=government%20building%20with%20dramatic%20storm%20clouds%2C%20investigation%20concept%2C%20dark%20moody%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20shadows%2C%20editorial%20photography&width=800&height=500&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-06-29',
    readTime: '6分钟',
    author: '正义使者',
    views: 5621000,
    tags: ['反腐', '官员落马', '社会热点', '贪污'],
    relatedArticles: ['4', '9', '12'],
  },
  {
    id: '4',
    slug: 'rexia-ju-zhujiao-baxi-huaixu',
    title: '热播剧男主角被曝剧组夫妻！与女二号假戏真做，正牌女友酒店抓现行',
    excerpt: '正在热播的古装剧《XX传》男女主角戏外也传出劲爆消息！据剧组工作人员爆料，男主与女二号在拍戏期间"假戏真做"，两人不仅在片场暧昧不断，还被拍到多次出入同一酒店房间...',
    content: `<p>近日，正在各大平台热播的古装剧《锦瑟传》戏外也上演了一出精彩大戏。据剧组场务人员爆料，男主角张某与饰演女二号的演员刘某在剧组期间"假戏真做"，关系远超普通同事。</p>

<p>爆料称，两人在片场经常借对戏之名独处，张某的房车成了两人的"秘密基地"。更有同剧组演员透露，两人经常在收工后一起回酒店，早上又一起出工，"全剧组都知道，只是没人说破"。</p>

<h3>正牌女友杀到片场</h3>

<p>最戏剧化的一幕发生在上周三。张某交往三年的圈外女友突然现身片场，直接冲到刘某的化妆间。据在场人员描述，当时化妆间内传出激烈的争吵声和摔东西的声音，持续了近二十分钟。</p>

<p>事后有人看到张某的女友红着眼眶离开，而张某和刘某当晚都被拍到提前离组。目前张某本人、工作室以及刘某均未对此事作出任何回应。</p>`,
    categoryId: '4',
    categoryName: '影视综艺',
    coverImage: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20drama%20film%20set%20behind%20the%20scenes%2C%20palace%20courtyard%20at%20dusk%2C%20dramatic%20romantic%20tension%2C%20warm%20golden%20lantern%20light%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-06-28',
    readTime: '5分钟',
    author: '剧组小透明',
    views: 4215600,
    tags: ['影视爆料', '剧组八卦', '假戏真做', '恋情曝光'],
    relatedArticles: ['1', '7', '11'],
  },
  {
    id: '5',
    slug: 'yixian-nanmingxing-hunyin-weiji',
    title: '一线男星婚姻亮红灯！妻子深夜发文称"心好累"，婚戒已摘，离婚的瓜要吃吗',
    excerpt: '某一线已婚男星近日被眼尖网友发现妻子已连续多日未戴婚戒，且妻子昨晚深夜在微博上发了一条意味深长的文字："有些路，走着走着就散了。心好累。"随后秒删...',
    content: `<p>近日，眼尖的网友发现某一线已婚男星陈某的妻子王某已经连续多日没有佩戴婚戒。这对一向以"恩爱夫妻"形象示人的明星夫妇，其婚姻状况引发广泛关注。</p>

<p>昨晚十一点左右，王某突然在个人微博上发布了一条意味深长的文字："有些路，走着走着就散了。心好累。"虽然该微博在发布不到一分钟内就被删除，但仍被大量网友截图保存。</p>

<h3>昔日恩爱形象碎一地</h3>

<p>陈某和王某于2018年结婚，婚后经常在公开场合秀恩爱，社交媒体上也频繁互动，被粉丝称为"模范夫妻"。然而近半年来，两人几乎零互动，陈某的生日王某没有送祝福，王某的新剧陈某也没有帮忙宣传。</p>

<p>更值得注意的是，陈某最近两次公开露面，其左手无名指上的婚戒都已不见踪影。当被记者问到婚姻状况时，陈某也只是含糊其辞地说"一切都好"，然后匆匆离开。</p>`,
    categoryId: '5',
    categoryName: '情感爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=wedding%20ring%20on%20dark%20velvet%20surface%20with%20dramatic%20single%20light%20source%2C%20lonely%20atmospheric%20mood%2C%20warm%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20cinematic%20still%20life%20photography&width=800&height=500&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-06-27',
    readTime: '4分钟',
    author: '情感侦探',
    views: 3124500,
    tags: ['婚姻危机', '明星夫妻', '离婚传闻', '婚戒'],
    relatedArticles: ['1', '8', '10'],
  },
  {
    id: '6',
    slug: 'douyin-baiwan-bozhu-renshe-bengta',
    title: '抖音百万博主"励志宝妈"人设崩塌！实则家里住别墅请三个保姆，老公是上市公司高管',
    excerpt: '靠"单亲妈妈艰苦奋斗养娃"故事走红抖音的百万粉丝博主"坚强妈妈小美"被扒出真实生活与视频内容天差地别。网友发现她实际住在价值两千多万的别墅中，家中有三个保姆...',
    content: `<p>抖音百万粉丝博主"坚强妈妈小美"凭借"单亲妈妈独自带俩娃、打三份工"的励志故事走红网络，收获了一百二十万粉丝的同情和支持。然而近日有网友扒出其真实生活与视频中展示的"艰辛"大相径庭。</p>

<p>有网友通过视频中偶然出现的窗外景色和小区环境，锁定了其居住的小区——当地著名的富人区，房价每平米超过八万。进一步深扒发现，该博主居住的独栋别墅市值超过两千五百万元。</p>

<h3>"单亲妈妈"真相令人咋舌</h3>

<p>更离谱的是，该博主并非视频中声称的"单亲妈妈"。其丈夫实为某上市公司高管，年薪超过五百万元。家中雇有三名保姆分别负责带孩子、做饭和打扫卫生。视频中"下班后赶回家给孩子做饭"的场景，实际只是摆拍。</p>

<p>事件曝光后，大量粉丝感到被欺骗，纷纷取关。该博主连夜删除了大量视频，并将账号设为私密。目前粉丝数已从一百二十万暴跌至不足十万。</p>`,
    categoryId: '6',
    categoryName: '社交媒体',
    coverImage: 'https://readdy.ai/api/search-image?query=social%20media%20influencer%20smartphone%20setup%20with%20fake%20backdrop%2C%20luxury%20lifestyle%20fakery%20concept%2C%20warm%20dramatic%20studio%20lighting%2C%20editorial%20photography%20with%20rich%20warm%20tones&width=800&height=500&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-06-26',
    readTime: '4分钟',
    author: '真相挖掘机',
    views: 4789200,
    tags: ['抖音翻车', '人设崩塌', '单亲妈妈', '摆拍'],
    relatedArticles: ['2', '9', '12'],
  },
  {
    id: '7',
    slug: 'liuxing-yuedui-chengyuan-xidu-beibu',
    title: '某流行乐队成员吸毒被捕！音乐节现场被警方带走，队友全程黑脸',
    excerpt: '昨晚在某大型音乐节压轴演出的知名乐队"XX乐队"突发状况！演出结束后，乐队鼓手在后台被 police 带走，据现场工作人员称是因涉毒。其他三名队友目睹全过程，面色铁青...',
    content: `<p>昨晚，在某大型音乐节压轴演出的知名摇滚乐队"燃烧青春"突发重大变故。演出结束后约十五分钟，乐队鼓手赵某在后台被警方当场带走，现场有多名工作人员和艺人目击。</p>

<p>据在场人员描述，当时四名 band 成员正在后台休息区庆祝演出顺利，突然冲进来几名便衣警察，直接向赵某出示了证件并将其控制。其他三名队友全程目睹，主唱李某的脸色"瞬间变得惨白"。</p>

<h3>乐队前途未卜</h3>

<p>"燃烧青春"乐队成立于2015年，是目前国内最受欢迎的摇滚乐队之一，拥有大量忠实粉丝。乐队原计划下个月开启全国巡演，目前看来能否如期举行已成未知数。</p>

<p>乐队经纪人于今晨发布声明，称"正在了解情况，请大家不要轻信谣言"。但警方随后发布的通报证实了赵某因涉嫌吸毒被行政拘留十五日的消息。</p>`,
    categoryId: '1',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=music%20festival%20stage%20at%20night%20with%20police%20lights%20flashing%2C%20dramatic%20backstage%20scene%2C%20rock%20concert%20atmosphere%2C%20warm%20stage%20lights%20mixed%20with%20cold%20blue%20police%20lights%2C%20cinematic%20photography&width=800&height=500&seq=article-cover-07&orientation=landscape',
    publishedAt: '2026-06-25',
    readTime: '5分钟',
    author: '现场目击',
    views: 5342100,
    tags: ['吸毒被捕', '乐队八卦', '音乐节', '娱乐圈'],
    relatedArticles: ['1', '4', '10'],
  },
  {
    id: '8',
    slug: 'zhibo-daihuo-shuju-zaojia-puguang',
    title: '直播间"万人疯抢"全是机器人！知名主播带货数据造假被技术大神实锤',
    excerpt: 'B站知名科技区UP主"代码侠"昨日发布了一条爆款视频，通过技术手段实锤某头部带货主播直播间内的"抢购热潮"实为机器人刷单。视频中详细展示了如何通过API接口抓取到数万条一致的机器人行为数据...',
    content: `<p>B站科技区UP主"代码侠"昨日发布了一条时长二十八分钟的技术分析视频，通过公开API接口数据抓取和分析，实锤了某头部带货主播直播间存在大规模机器人刷单行为。</p>

<p>视频中，"代码侠"展示了抓取的十万条观众行为数据，发现其中超过七成的账号具有高度一致的行为模式：同一时间进入直播间、同一频率发送固定弹幕、在同一时间点下单。这些账号的注册时间也高度集中在近三个月内，且几乎都没有头像和动态。</p>

<h3>数据触目惊心</h3>

<p>更令人震惊的是，该直播间宣称"三秒售罄"的某款商品，实际真实下单量仅占显示销量的百分之八左右。也就是说，直播间展示的十万单销量中，真实买家可能不足八千。</p>

<p>被实锤的主播团队随后发声明否认，并威胁要起诉"代码侠"侵犯名誉权。但"代码侠"表示所有数据均来自公开接口，"欢迎来告，法庭上见"。</p>`,
    categoryId: '2',
    categoryName: '网红黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=computer%20screen%20with%20code%20and%20data%20analytics%20charts%2C%20livestream%20interface%20with%20fake%20engagement%20metrics%2C%20warm%20amber%20screen%20glow%2C%20dark%20room%20atmosphere%2C%20editorial%20tech%20photography&width=800&height=500&seq=article-cover-08&orientation=landscape',
    publishedAt: '2026-06-24',
    readTime: '6分钟',
    author: '代码侠',
    views: 6234500,
    tags: ['数据造假', '直播带货', '机器人刷单', '技术实锤'],
    relatedArticles: ['2', '6', '9'],
  },
  {
    id: '9',
    slug: 'wangluo-qizha-jituan-duanwo-beiduan',
    title: '网络诈骗集团老巢被端！涉案金额超五亿，受害者遍布全国三十二省市',
    excerpt: '公安部今日通报，一个盘踞在某东南亚国家的特大电信网络诈骗集团被成功捣毁。警方在国内外同步收网，抓获犯罪嫌疑人三百余名，涉案金额初步统计超过五亿元人民币...',
    content: `<p>公安部刑事侦查局今日召开新闻发布会，通报了一起特大跨国电信网络诈骗案的侦破情况。一个盘踞在某东南亚国家长达五年的诈骗集团被成功捣毁，警方在国内外同步收网，抓获犯罪嫌疑人三百四十二名。</p>

<p>据悉，该诈骗集团以"高薪兼职刷单""投资理财返利"等名义实施诈骗，受害者遍布全国三十二个省市自治区，初步统计涉案金额高达五点三亿元，受害者人数超过一万两千人。</p>

<h3>诈骗手段层层设套</h3>

<p>据专案组负责人介绍，该集团组织严密、分工明确。底层"拉手"负责在社交平台上物色目标，以小额返利为诱饵骗取信任；"导师"负责诱导受害者加大投入；"财务"负责资金转移和洗钱。整个流程环环相扣，一旦受害者入套，很难全身而退。</p>

<p>值得注意的是，该集团专门针对三十五至五十五岁的中年人群，利用其对互联网不够熟悉、有一定积蓄又想理财赚钱的心理弱点实施诈骗。</p>`,
    categoryId: '3',
    categoryName: '社会热点',
    coverImage: 'https://readdy.ai/api/search-image?query=police%20raid%20operation%20at%20night%2C%20fraud%20call%20center%20bust%2C%20dramatic%20red%20and%20blue%20emergency%20lights%2C%20cybercrime%20investigation%20concept%2C%20warm%20and%20cold%20light%20contrast%2C%20editorial%20photography&width=800&height=500&seq=article-cover-09&orientation=landscape',
    publishedAt: '2026-06-23',
    readTime: '5分钟',
    author: '法制在线',
    views: 7123800,
    tags: ['网络诈骗', '社会热点', '公安部通报', '跨国诈骗'],
    relatedArticles: ['3', '6', '12'],
  },
  {
    id: '10',
    slug: 'yixian-nvxing-yuehui-xiaoxianrou',
    title: '一线女星被拍到与年下小鲜肉同游日本！男方比她小十二岁，甜蜜喂食超暧昧',
    excerpt: '某一线实力派女演员近日被粉丝在日本东京偶遇，身边陪同的竟是一位长相帅气的年轻男子。两人举止亲密，在餐厅被拍到互相喂食的画面。据男方身份信息被扒，系某知名艺术学院在读研究生...',
    content: `<p>某一线实力派女演员周某近日被网友在日本东京某餐厅偶遇，同行的年轻男子引发热议。照片显示，两人在餐厅内举止亲密，周某不仅亲手为男子整理头发，还被拍到互相喂食甜点的画面。</p>

<p>随后，男方的身份信息被网友扒出。该男子系某知名艺术学院表演系在读研究生，今年二十四岁，比四十五岁的周某小了整整二十一岁。更巧的是，该男子曾在周某主演的一部电视剧中担任过群演。</p>

<h3>双方保持沉默</h3>

<p>周某此前有过一段持续八年的婚姻，于2023年低调离婚，此后一直专注于演艺事业。这次日本之行被拍到后，双方均未作出任何回应。周某工作室也只是例行公事地发布了"不回应私生活"的声明。</p>

<p>不过，细心的网友发现，该男子近期的社交媒体上频繁出现与周某同款的手链和帽子，且IP地址多次与周某行程重合。这段"姐弟恋"的瓜，看来还有的吃。</p>`,
    categoryId: '1',
    categoryName: '明星八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20restaurant%20interior%20with%20warm%20ambient%20lighting%2C%20romantic%20dining%20scene%2C%20sakura%20decorations%2C%20intimate%20atmosphere%2C%20soft%20golden%20hour%20light%20through%20windows%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=article-cover-10&orientation=landscape',
    publishedAt: '2026-06-22',
    readTime: '4分钟',
    author: '娱乐圈内鬼',
    views: 4567800,
    tags: ['姐弟恋', '明星恋情', '日本同游', '年下男'],
    relatedArticles: ['1', '5', '7'],
  },
  {
    id: '11',
    slug: 'zhenxiu-zongyi-heimu-baoguang',
    title: '某选秀综艺黑幕曝光！出道位早已内定，选手缴纳百万"出道费"才能晋级',
    excerpt: '正在热播的某选秀综艺被前工作人员爆出惊人黑幕！据爆料，节目所谓的"全民投票"出道完全是幌子，实际出道位在录制前就已内定。更惊人的是，有选手家属为了让孩子晋级，向节目组缴纳了高达百万的"出道费"...',
    content: `<p>正在热播的选秀综艺《青春造梦营》被一名前工作人员在社交平台上爆出惊人黑幕。该工作人员称，节目标榜的"全民投票决定出道位"完全是幌子，实际七个出道位在节目正式录制前就已经内定完毕。</p>

<p>爆料还称，部分选手家属为了让自家孩子"顺利出道"，通过中间人向节目组相关负责人输送巨额资金。其中一名排名前五的选手，其家属向节目组缴纳了高达一百二十万元的"赞助费"。</p>

<h3>投票系统疑作假</h3>

<p>该前工作人员进一步透露，节目的投票系统存在严重漏洞，节目组可以随时在后台修改投票数据。"有时候看到某位选手实时票数涨得太快，节目组会觉得'不符合剧本'，就直接在后台把票数调低。"</p>

<p>目前，该综艺的制作方已发布声明否认所有指控，并称要对爆料者追究法律责任。但爆料者表示"手里还有更猛的料，等着看"。</p>`,
    categoryId: '4',
    categoryName: '影视综艺',
    coverImage: 'https://readdy.ai/api/search-image?query=talent%20show%20stage%20with%20dramatic%20spotlights%2C%20voting%20scoreboard%20manipulation%20concept%2C%20dark%20backstage%20corridor%2C%20warm%20stage%20lights%20with%20cold%20shadows%2C%20cinematic%20entertainment%20photography&width=800&height=500&seq=article-cover-11&orientation=landscape',
    publishedAt: '2026-06-21',
    readTime: '5分钟',
    author: '节目内幕',
    views: 3891200,
    tags: ['选秀黑幕', '综艺爆料', '内定出道', '投票作假'],
    relatedArticles: ['4', '7', '12'],
  },
  {
    id: '12',
    slug: 'xiaohongshu-baokuan-biji-shanzao',
    title: '小红书爆款笔记全是编的！专业代写团队曝光，一条"真实分享"收费三千',
    excerpt: '一个专门在小红书代写爆款笔记的团队近日被前员工曝光。该团队专门为客户编造"真实使用体验"，每条笔记收费三千至八千元不等。团队内部甚至有专门的"造假培训"，教写手如何编造令人信服的故事...',
    content: `<p>一个专业的小红书代写团队近日被前员工在社交媒体上曝光。该团队专门为各类品牌和个人编造"真实使用体验"笔记，收费从每条三千元到八千元不等，视"爆款程度"定价。</p>

<p>据爆料，团队内部甚至有专门的"造假培训"课程，教新入职的写手如何编造令人信服的个人故事。"比如说推荐减肥产品，就要编一个'产后抑郁、老公嫌弃、减肥成功重获自信'的三段式故事，这样最容易引起共鸣。"</p>

<h3>造假产业链惊人</h3>

<p>更令人震惊的是，该团队还开发了完整的"数据维护"服务，包括刷点赞、刷评论、刷收藏，甚至提供"真人水军"在评论区互动，制造笔记火爆的真实感。</p>

<p>小红书官方随后发布声明，称已封禁该团队关联的上百个账号，并将配合有关部门进行调查。但网友普遍对平台的审核机制表示质疑："这些假笔记都爆了这么久才发现，平时怎么审核的？"</p>`,
    categoryId: '6',
    categoryName: '社交媒体',
    coverImage: 'https://readdy.ai/api/search-image?query=social%20media%20content%20creation%20fake%20concept%2C%20multiple%20smartphones%20with%20staged%20lifestyle%20photos%2C%20warm%20soft%20studio%20lighting%2C%20content%20farm%20aesthetic%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=500&seq=article-cover-12&orientation=landscape',
    publishedAt: '2026-06-20',
    readTime: '4分钟',
    author: '打假先锋',
    views: 5432100,
    tags: ['小红书造假', '代写笔记', '社交媒体', '虚假分享'],
    relatedArticles: ['2', '6', '8'],
  },
];